import React from "react";
import RecentComments from "../Comments/RecentComments";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getLatestComment } from "../../../3- actions/comments";
import { unwrapResult } from "@reduxjs/toolkit";
import { getUserComment } from "../../../3- actions/users";
import { getLatestNovelComments } from "../../../3- actions/novels";
import Skeleton from "./Skeleton";
function CommentsSlider() {
  function SwiperPdding() {
    const swipers = document && document.querySelectorAll(".swiper")[2];
    if (swipers) {
      swipers.classList.add("swiper" + 3);
    }
  }
  const dispatch = useDispatch();
  const latestComments = useSelector(
    (state) => state.commentsData.latestComments
  );
  const skeleton = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}];
  const latestNovelComments = useSelector(
    (state) => state.novelsData.latestNovelComments
  );
  const latestUsers = useSelector((state) => state.user.userComment);
  useEffect(() => {
    dispatch(getLatestComment())
      .then(unwrapResult)
      .then((obj) => {
        dispatch(getUserComment(obj.map((a) => a.User_id)));
        dispatch(getLatestNovelComments(obj.map((a) => a.Novel_id)));
      });
  }, []);

  setTimeout(() => {
    SwiperPdding();
  }, 500);

  return (
    <div className="sm:mt-[100px] mt-[50px] mb-[200px] relative">
      <div className=" pt-4 overflow-hidden px-[15px] md:px-0 relative">
        <div>
          <div className="relative w-auto flex  justify-center sm:justify-start md:justify-center items-center ">
            <h1 className="text-center whitespace-nowrap font-size relative text-tertiary ">
              Latest REVIEWS
              <span className="absolute font-Cclassic capitalize font-size-stylish text-primary">
                New
              </span>
            </h1>
          </div>
        </div>
        <div className="bg-primary h-[45%] mt-[50px] w-full absolute purple-full-width"></div>
        <div className="mt-[50px] relative">
          <Swiper
            // install Swiper modules
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={40}
            slidesPerView={1}
            navigation
            pagination={{
              type: "progressbar",
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 32,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1280: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
              1536: {
                slidesPerView: 2,
                spaceBetween: 40,
              },
            }}
          >
            {latestComments?.latestComments?.map((comment) => (
              <SwiperSlide key={Math.random()}>
                <RecentComments
                  latestNovelComments={latestNovelComments}
                  latestUsers={latestUsers}
                  comment={comment}
                />
              </SwiperSlide>
            ))}
            {latestComments?.pending === true
              ? skeleton.map(() => (
                  <SwiperSlide key={Math.random()}>
                    <Skeleton />
                  </SwiperSlide>
                ))
              : null}
          </Swiper>
          <div className="absolute right-0 mt-10 sm:mt-0 sm:-bottom-[75px] -bottom-[50px]  text-tertiary font-SoraL uppercase text-[12px]">
            Scroll
          </div>
        </div>
        <div className="my-carousel-progress mt-[75px] relative">
          <div className="my-carousel-progress-bar"></div>
          <div className="absolute right-0 text-tertiary font-SoraL mt-2 uppercase text-[12px]">
            Scroll
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommentsSlider;
